import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { INTERVIEW_STATUS_DECLINE } from '../../../../../../define/consts/rfp/rfp_interview_define';
import { propArrayShape, propShape, } from '../../../../../../helpers/custom-prop-types';
import ViewRequestTable from '../ViewRequestTable/ViewRequestTable';
import CompleteTop from './Parts/CompleteTop';
import FinalContractor from './Parts/FinalContractor/FinalContractor';
const OrderComplete = (props) => {
    const { offers, rfp } = props;
    const showOffers = useMemo(() => offers.filter((v) => v.offer.interview_status === INTERVIEW_STATUS_DECLINE.value), [offers]);
    return (_jsxs("div", Object.assign({ className: 'rfp_order_complete' }, { children: [_jsx(CompleteTop, { rfp: rfp }), _jsxs("div", Object.assign({ className: 'content_row result_row' }, { children: [_jsx("h5", Object.assign({ className: 'content_title' }, { children: "\u672C\u6848\u4EF6\u306E\u7D50\u679C" })), _jsx(FinalContractor, { offers: offers, rfp: rfp })] })), showOffers.length > 0 && (_jsx("div", Object.assign({ className: 'content_row' }, { children: _jsx(ViewRequestTable, { isSort: false, viewRequests: showOffers }) })))] })));
};
OrderComplete.propTypes = {
    offers: propArrayShape().isRequired,
    rfp: propShape().isRequired,
};
export default OrderComplete;
